import React, {Component} from 'react'
import './ListTable.css'
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import StyledTableHead from './StyledTableHead';
import StyledTableBody from './StyledTableBody';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import ContextMenu from '../../FunctionArea/ContextMenu'


const wStyles = theme => ({
    TableContainerNotFullScreen: {
       height:"53vh"
    },
    TableContainerFullScreen: {
        height:"90vh"
     },
})

class ListTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataState:0,
            //listData:[],
            orderColumn:null,
            orderType:null,
            contextManu:{
                status:false,
                pos:null,
                conID:null,
                command:null,
                from:null,
            },
        }
    }

    componentDidMount(){
       this.refreshState()
    }

    componentDidUpdate(prevProps,prevState){
        if(prevProps.storedOrderColumn !== this.state.orderColumn || prevProps.storedOrderType !== this.state.orderType)
        {
            this.refreshState()
        }
    }


    refreshState=()=>{
        this.setState({
            orderColumn:this.props.storedOrderColumn,
            orderType:this.props.storedOrderType
        })
    }
    
    handleEventListClicked = (msg) => {
        if(this.state.contextManu.status)
        {
            this.setState({
                contextManu:{
                    status:false,
                    pos:null,
                    conID:null,
                    command:null,
                    from:null
                },
            })
        }
        else
        {
            this.props.getSelectedEvent(msg)
        }
    }

    getNewOrderStatus = (msg) => {
        console.log(msg)
        if(msg === this.state.orderColumn)
        {
            if(this.state.orderType === "ASC")
            {
                this.setState({
                    orderType:"DESC"
                })

                let sentMsg={
                    orderColumn:msg,
                    orderType:"DESC"
                }
                this.props.getOrderStatus(sentMsg)
            }
            else
            {
                this.setState({
                    orderType:"ASC"
                })

                let sentMsg={
                    orderColumn:msg,
                    orderType:"ASC"
                }
                this.props.getOrderStatus(sentMsg)
            }
        }
        else
        {
            this.setState({
                orderColumn:msg,
                orderType:"ASC"
            })

            let sentMsg={
                orderColumn:msg,
                orderType:"ASC"
            }
            this.props.getOrderStatus(sentMsg)
        }
    }

    openContextManu=(msg)=>{
        this.setState({
            contextManu:{
                status:true,
                pos:msg.pos,
                conID:msg.ID,
                command:null,
                from:"EventList",
            },
        })

    }

    getCommand=(msg)=>{
        console.log("msg : ",msg)
        if(msg==="delete")
        {
            this.props.deleteRow(this.state.contextManu.conID)
            this.setState({
                contextManu:{
                    status:false,
                    pos:null,
                    conID:null,
                    command:null,
                    from:null
                },
            })
        }
    }

    onClick=()=>{
        this.setState({
            contextManu:{
                status:false,
                pos:null,
                conID:null,
                command:null,
                from:null
            },
        })
    }

    render(){
        //let text = this.state.listData[0]?this.state.listData[0].Event_Title:"Not Ready"
        const {classes} = this.props;
    
        return(
            
            <TableContainer className={this.props.fullScreen?classes.TableContainerFullScreen:classes.TableContainerNotFullScreen} component={Paper} onClick={this.onClick}>
                <Table aria-label="customized table" stickyHeader>
                    <StyledTableHead orderColumn={this.state.orderColumn} orderType={this.state.orderType} getNewOrderStatus={this.getNewOrderStatus}/>
                    <StyledTableBody listData={this.props.listData} handleEventListClicked={this.handleEventListClicked} openContextManu={this.openContextManu}/>              
                </Table>
                {this.state.contextManu.status? <ContextMenu pos={this.state.contextManu.pos} prevConID={this.state.contextManu.conID} prevCommand={this.state.contextManu.command} invokeFrom={this.state.contextManu.from} getCommand={this.getCommand}/>:null}
            </TableContainer>
        )
    }

}

export default withStyles(wStyles)(ListTable)
